import React, { useState } from 'react';

import AssetService from '../../../../shared/services/AssetService';
import { FlipCardItem } from '../../../models/LessonComponentContent';
import IconButton from '@mui/material/IconButton';
import { ItemModel } from '../../../models/ItemModel';
import LessonComponentService from '../../../../content/services/LessonComponentService';
import ReactCardFlip from 'react-card-flip';
import SpinIcon from '../../../images/spin-circle.svg';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import VisitedIcon from '../../../images/visited.svg';
import styles from '../../../styles/FlipCard.module.scss';
import { useLessonContext } from '../../../models/LessonContext';

interface FlipEachProps {
  flipCard: FlipCardItem;
  response: string;
  onSubmit: (response: string) => void;
}

export const FlipEach = (props: FlipEachProps) => {
  const { flipCard } = props;
  const [isFlipped, setIsFlipped] = useState<boolean>(false);

  const { mode } = useLessonContext();

  let flipped: ItemModel[] =
    (props.response && JSON.parse(props.response)) || [];

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
    if (!flipped.find((i) => i.itemId === flipCard.id)) {
      props.onSubmit(JSON.stringify([...flipped, { itemId: flipCard.id }]));
    }
  };
  const hasFlipped = () => {
    return flipped?.map(({ itemId }) => itemId).includes(flipCard.id);
  };

  return (
    <div>
      <ReactCardFlip isFlipped={isFlipped}>
        <div onClick={handleFlip} className={styles.imgContainer}>
          {flipCard.frontImage ? (
            <img
              src={AssetService.getAssetUrl(flipCard.frontImage)}
              alt={flipCard.frontLabel}
              className={styles.img}
            />
          ) : (
            <div></div>
          )}
          {flipCard.frontLabel && (
            <Tooltip
              title={LessonComponentService.stripTags(flipCard.frontLabel)}
              placement="bottom"
              arrow
            >
              <Typography
                className={`${styles.flipCardLabel} ${
                  flipCard.frontImage && styles.labelWithImage
                }`}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: LessonComponentService.getUrlWithSas(
                      flipCard.frontLabel
                    )
                  }}
                ></span>
              </Typography>
            </Tooltip>
          )}
          <IconButton
            size="small"
            className={styles.buttonPosition}
            onClick={handleFlip}
          >
            <img src={SpinIcon} alt="flip" />
          </IconButton>
          {hasFlipped() && mode === 'mark' && (
            <div className={styles.flippedPosition}>
              <img src={VisitedIcon} alt="flipped" />
            </div>
          )}
        </div>
        <div onClick={handleFlip} className={styles.imgContainer}>
          {flipCard.backImage ? (
            <img
              src={AssetService.getAssetUrl(flipCard.backImage)}
              alt={flipCard.backLabel}
              className={styles.img}
            />
          ) : (
            <div></div>
          )}
          {flipCard.backLabel && (
            <Tooltip
              title={LessonComponentService.stripTags(flipCard.backLabel)}
              placement="bottom"
              arrow
            >
              <Typography
                className={`${styles.flipCardLabel} ${
                  flipCard.backImage && styles.labelWithImage
                }`}
              >
                <span
                  dangerouslySetInnerHTML={{
                    __html: LessonComponentService.getUrlWithSas(
                      flipCard.backLabel
                    )
                  }}
                ></span>
              </Typography>
            </Tooltip>
          )}
          <IconButton
            size="small"
            className={styles.buttonPosition}
            onClick={() => setIsFlipped(!isFlipped)}
          >
            <img src={SpinIcon} alt="flip" />
          </IconButton>
          {hasFlipped() && mode === 'mark' && (
            <div className={styles.flippedPosition}>
              <img src={VisitedIcon} alt="flipped" />
            </div>
          )}
        </div>
      </ReactCardFlip>
    </div>
  );
};
